import { Sheet, SheetContent } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import React from 'react';

export interface NestedFormDrawerProps {
  children: React.ReactNode;
  isOpen: boolean;
  close: () => void;
  panelClassName?: string;
  showDragHandle?: boolean;
  /** Accessible dialog title for screen readers. Defaults to "Form". */
  title?: string;
}

export function NestedFormDrawer({
  children,
  isOpen,
  close,
  panelClassName = '',
  showDragHandle = true,
  title = 'Form',
}: NestedFormDrawerProps) {
  const contentRef = React.useRef<HTMLDivElement>(null);
  return (
    <Sheet
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) close();
      }}
    >
      <SheetContent
        side="bottom"
        dismissible={showDragHandle}
        srTitle={title}
        className={cn('bg-bg-secondary', panelClassName)}
        onOpenAutoFocus={(e) => {
          // Don't jump focus to a form field (it scrolls); just move focus into the dialog
          // so keyboard and screen-reader users land inside it. ESC still closes.
          e.preventDefault();
          contentRef.current?.focus();
        }}
      >
        <div
          ref={contentRef}
          tabIndex={-1}
          className="flex-1 min-h-0 w-full overflow-y-auto overscroll-contain outline-none flex flex-col items-center px-10 pt-5 pb-12"
        >
          {/* Same centred column as the other form bottom sheets (e.g. AddPersonBottomsheet). */}
          <div className="h-full w-full max-w-xl">{children}</div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
